import React, { useEffect, useState } from "react";
import "./PageLoader.css";

interface PageLoaderProps {
  variant: "website" | "admin";
}

const PageLoader: React.FC<PageLoaderProps> = ({ variant }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const timeoutId = window.setTimeout(() => setVisible(false), 850);
    return () => window.clearTimeout(timeoutId);
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <div className={`page-loader page-loader--${variant}`}>
      <div className='page-loader__inner'>
        <div className='page-loader__ring'></div>
        <strong>
          {variant === "admin" ? "Opening Admin Panel" : "Loading Dialin24"}
        </strong>
        <span>
          {variant === "admin"
            ? "Preparing secure workspace..."
            : "Preparing page content..."}
        </span>
      </div>
    </div>
  );
};

export default PageLoader;
